import React from "react";
import banner from "../../Asset/recent/banner.png";
import { BsFillStarFill } from "react-icons/bs";
import { FaRupeeSign } from "react-icons/fa";
import { FaShoppingCart } from "react-icons/fa";
import { FaCartPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import cart from "../../Asset/recent/cart.png";
import cart1 from "../../Asset/recent/cart1.png";
import cartModel from "../../model/cart.model";
import { toast } from "../../lib/helper";
import logo from "../../Asset/ordercard/logo.png";
import wrong from "../../Asset/toast/wrong.png"
import addcart from "../../Asset/toast/addcart.png"

const Card = ({ item }) => {
  const Navigate = useNavigate();
 
  const AddCart = async (carttype) => {
    const form = new FormData();

    form.append("cart_type", carttype);
    form.append("quantity", "1");
    form.append("product_id", item?._id);
    cartModel
      .Addcart(form)
      .then((responce) => {
        toast(responce?.data?.message, addcart);
        console.log("cart add", responce);
      })
      .catch((error) => {
        console.log("error", error);
        toast(error?.response?.data?.message, wrong);
      });
  };

  return (
    <div
      className="bg-Background1  rounded-2xl w-full flex justify-center py-8 cursor-pointer transform transition duration-300 hover:scale-105"
      onClick={() => {
        Navigate(`/productdetail/${item?._id}`);
      }}
    >
      <div className="w-5/6 flex flex-col">
        <div className="w-full  h-80 border-2 border-Border1  relative ">
          <img
            src={item?.profile_image?.location}
            className="w-full h-full object-cover  "
            alt=""
          />
          <div className="-top-0.5 left-1/2 w-3/5 absolute transform -translate-x-1/2 ">
            <img src={banner} className="w-full object-cover" alt="" />
            <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-textColor font-bold text-xs  whitespace-nowrap">
              {item?.tag}
            </span>
          </div>
        </div>
        <div className="flex mt-2 mb-2">
          <span className="text font-semibold">{item?.name}</span>
        </div>
        <div className="flex justify-between  items-center ">
          <div className="flex items-center gap-2 ">
            <div className="flex gap-2">
              <span className="text-yellow-400">
                <BsFillStarFill />
              </span>
            </div>
            <span className="text-md font-semibold text-gray-400">
              {item?.rating}.0
            </span>
          </div>
          <div>
            <span className="text-sm font-bold text-gray-400">
              {item?.quantity} {item?.unit_type}
            </span>
          </div>
        </div>
        <div className="flex justify-between mt-3 items-center ">
          <div className="flex items-center gap-2 ">
            <span className="">
              <FaRupeeSign />
            </span>
            <span className="font-bold">
              {item?.regular_price?.discount_price}
            </span>
          </div>
          <div>
            <span className={`${item?.is_subscribed ? "bg-Background2 cursor-pointer" : "bg-gray-200 cursor-not-allowed"} px-2 py-1  text-textColor font-semibold rounded-md text-sm`}
             onClick={(e) => {
                e.stopPropagation();
                if (item?.is_subscribed) {
                  AddCart("subscription");
                }
              }}>
              Subscribe @ {item?.is_subscribed && "₹"} {item?.is_subscribed && item?.subscription_price?.mrp_price}
            </span>
          </div>
        </div>
        <div className="flex justify-between mt-2 items-center ">
          <div
            className={`flex items-center gap-2 ${item?.is_cart ? "bg-textColor hover:text-gray-200 cursor-pointer text-white" :"bg-gray-200 cursor-not-allowed text-textColor"}  px-2 py-1 rounded-md font-bold text-sm `}
            onClick={(e) => {
              if(item?.is_cart){
              AddCart("regular");
              }
              e.stopPropagation();
            }}
          >
            <span className="">
              <FaShoppingCart />
            </span>
            <span>+ Cart</span>
          </div>
          <div
            className={`flex items-center ${item?.is_pre_order ? "bg-textColor text-white hover:text-gray-200 cursor-pointer" :"bg-gray-200 cursor-not-allowed text-textColor"}  px-2 py-1 rounded-md font-bold text-sm `}
            onClick={(e) => {
              if(item?.is_pre_order){
              AddCart("pre_order");}
              e.stopPropagation();
            }}
          >
            <span className=" px-2 py-0.5 rounded-xl">
              <div className="w-4 h-4">
                {item?.is_pre_order ? 
                <img src={cart} alt="" className="w-full h-full" />:
                <img src={cart1} alt="" className="w-full h-full" />}
              </div>
            </span>{" "}
            <span> + Pre Order</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;
